import Swiper, { Navigation, Pagination, Lazy } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy]);

const swiperOne = new Swiper('.swiper-one', {
	watchSlidesProgress: false,
	preloadImages: false,
	spaceBetween: 20,
	loop: true,
	lazy: {
		loadPrevNext: true,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '">' + (this.slides[index+1].dataset.title) + "</span>";
		},
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
			spaceBetween: 4,
		},
		768: {
			spaceBetween: 10,
		},
		992: {
			spaceBetween: 15,
		},
		1199: {
			spaceBetween: 20,
		}
	},
});

const swiperTwo = new Swiper('.swiper-building', {
	watchSlidesProgress: false,
	preloadImages: false,
	spaceBetween: 20,
	loop: true,
	slidesPerView: "auto",
	centeredSlides: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
			spaceBetween: 4,
		},
		768: {
			spaceBetween: 10,
		},
		992: {
			spaceBetween: 15,
			slidesPerView: 1,
		},
		1199: {
			spaceBetween: 20,
			slidesPerView: "auto",
		}
	},
});

const swiperTree = new Swiper('.swiper-primary', {
	watchSlidesProgress: false,
	preloadImages: false,
	spaceBetween: 20,
	loop: true,
	slidesPerView: "auto",
	centeredSlides: true,
	lazy: {
		loadPrevNext: true,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '">' + (this.slides[index].dataset.title) + "</span>";
		},
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
			spaceBetween: 4,
		},
		768: {
			spaceBetween: 10,
		},
		992: {
			spaceBetween: 15,
		},
		1199: {
			spaceBetween: 20,
		}
	},
});

const swiperSecondary = new Swiper('.swiper-secondary', {
	watchSlidesProgress: false,
	preloadImages: false,
	spaceBetween: 20,
	loop: true,
	slidesPerView: "auto",
	centeredSlides: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
			spaceBetween: 4,
		},
		768: {
			spaceBetween: 10,
		},
		992: {
			spaceBetween: 15,
		},
		1199: {
			spaceBetween: 20,
		}
	},
});
